import { BaseEntityResource } from '@/modules/core/app/resources/BaseEntityResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { ClientGroup } from '@/modules/ta/clientgroup/models/ClientGroup';

export class ClientGroupResource extends BaseEntityResource {
  constructor() {
    super(RouteGroup.CLIENTGROUPS, ClientGroup);
  }

  /**
   * @param params
   * @param config
   * @returns {Promise<*>}
   */
  async getValues(params = {}, config = {}) {
    return super.getValuesUsingPost(params, config);
  }
}

export default new ClientGroupResource();
